export default class Rte {
	constructor(config) {
		this.el = config.el || document.querySelector(".rte");
		this.ctas = config.el.querySelectorAll(".macro__cta");
		this.init();
	}
	init() {
		this.addEventListeners();
		if (utilities.getSize() !== "xsmall") {
			this.updateCtaHeights();
		}
		if (utilities.getSize() == "xsmall" || utilities.getSize() == "small") {
			this.resetCtaHeights();
		}
	}

	addEventListeners() {
		const self = this;
		window.addEventListener("resize", function() {
			if (utilities.getSize() !== "xsmall") {
				self.updateCtaHeights();
			} else {
				self.resetCtaHeights();
			}
		});
		utilities.emitter.on("responsive/sizechange", size => {
			if (size == "xsmall" || size == "small") {
				self.resetCtaHeights();
			}
		});
	}
	updateCtaHeights() {
		const self = this;
		var tallestHeight = 0;
		setTimeout(function() {
			self.resetCtaHeights();
			self.ctas.forEach(cta => {
				const ctaInner = cta.querySelector(".cta");
				const height = ctaInner.scrollHeight;
				if (height > tallestHeight) {
					tallestHeight = height;
				}
			});
			self.ctas.forEach(cta => {
				if (cta.classList.contains("cta--small")) {
					self.setHeight(cta, tallestHeight);
				} else {
					// tallestHeight = 0;
				}
			});
		}, 1);
	}
	resetCtaHeights() {
		this.ctas.forEach(cta => {
			this.resetHeight(cta);
		});
	}
	setHeight(cta, height) {
		cta.style.height = height + "px";
	}
	resetHeight(cta) {
		cta.style.height = "";
	}
}
